import React from 'react'
import PropTypes from 'prop-types'

export default function CrosshairIcon(props) {
  return (
    <svg width={props.width} height={props.height} viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_d_4926_197797)'>
        <g filter='url(#filter1_d_4926_197797)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M9.99995 6.92593V1H10.9999V6.92593H9.99995ZM9.99995 16.9999V11.074H10.9999V16.9999H9.99995ZM18.4999 8.5H12.574L12.574 9.5H18.4999V8.5ZM2.5 8.5L8.42593 8.5V9.5H2.5L2.5 8.5ZM10.5 9.59261C10.8272 9.59261 11.0926 9.32729 11.0926 9.00001C11.0926 8.67273 10.8272 8.40742 10.5 8.40742C10.1727 8.40742 9.90737 8.67273 9.90737 9.00001C9.90737 9.32729 10.1727 9.59261 10.5 9.59261Z'
            fill={props.color}
          />
        </g>
      </g>
      <defs>
        <filter id='filter0_d_4926_197797' x='2.5' y='1' width='17' height='17' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx='1' dy='1' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_4926_197797' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_4926_197797' result='shape' />
        </filter>
        <filter id='filter1_d_4926_197797' x='0.5' y='0' width='20' height='20' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy='1' />
          <feGaussianBlur stdDeviation='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_4926_197797' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_4926_197797' result='shape' />
        </filter>
      </defs>
    </svg>
  )
}

CrosshairIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number
}

CrosshairIcon.defaultProps = {
  color: '#fafafa',
  height: 20,
  width: 21
}
